import { Alert, Box, Button, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import PostService from '../../services/PostService';
import { taskErrorMessage } from '../../services/TaskTrackingService';
import { formatShortDate } from '../../utils/dates';
import { shortName } from './taskUi';

/** Admins: posts in the trash, kept for 30 days. */
const DeletedPostsList = () => {
    const [posts, setPosts] = useState(null);
    const [error, setError] = useState(null);

    const load = () =>
        PostService.deleted()
            .then(setPosts)
            .catch((e) => setError(taskErrorMessage(e)));

    useEffect(() => {
        load();
    }, []);

    const restore = async (post) => {
        try {
            await PostService.restore(post.id);
            load();
        } catch (e) {
            setError(taskErrorMessage(e));
        }
    };

    return (
        <>
            {posts?.length === 0 && <Typography variant="body2">No deleted posts.</Typography>}
            {(posts || []).map((p) => (
                <Box key={p.id} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, py: 0.75 }}>
                    <Box sx={{ minWidth: 0 }}>
                        <Typography variant="body2">{p.title}</Typography>
                        <Typography variant="caption" color="text.secondary">
                            {p.languages} language{p.languages === 1 ? '' : 's'} · deleted {formatShortDate(p.deletedAt)} by {shortName(p.deletedBy)}
                        </Typography>
                    </Box>
                    <Button size="small" onClick={() => restore(p)}>
                        Restore
                    </Button>
                </Box>
            ))}
            {error && <Alert severity="error">{error}</Alert>}
        </>
    );
};

export default DeletedPostsList;
